import { connect } from 'react-redux';

import { selectActiveVenueId } from 'selectors/general';
import { selectSchedulesClasses, selectSelectedClassIdFilter } from '../../Schedules.selectors';
import { setSchedulesBoardClassesFilters } from '../../Schedules.reducers';
import ScheduleBoardClassFilter from './ScheduleBoardClassFilter';

const mapStateToProps = state => {
  const venueId = selectActiveVenueId(state);
  return {
    classes: selectSchedulesClasses(state, venueId),
    selectedClasses: selectSelectedClassIdFilter(state),
  };
};

const mapDispatchToProps = { updateSelection: classes => setSchedulesBoardClassesFilters(classes) };

export default connect(mapStateToProps, mapDispatchToProps)(ScheduleBoardClassFilter);
